export default "__VITE_ASSET__DldxdyiU__"